import { useContext, useEffect, useState, ComponentProps } from 'react';
import { connect } from 'react-redux';
import { useUnmountPromise } from 'react-use';

import * as actions from '../../../vehicles/store/actions';
import { FormContext, SelectInput } from '../forms';

/** Минимальный структурный тип элемента справочника моделей (готового интерфейса в vehicles/api нет). */
interface VehicleModelItem {
  id: string | number,
  title?: string,
}

type VehicleModelSelectorProps = Omit<ComponentProps<typeof SelectInput>,
  'value' | 'defaultValue' | 'onChange'> &{
  makeId?: string | number,
  disabled?: boolean,
  onChange?: (event: any) => void,
  /** из mapStateToProps */
  models?: VehicleModelItem[],
  /** из mapDispatchToProps */
  getVehicleModels: (makeId?: string | number) => Promise<unknown>,
};

const VehicleModelSelector = (props: VehicleModelSelectorProps) => {
  const mounted = useUnmountPromise();
  // FormContext создаётся в utils.js без дженерика — приводим к нужной форме (см. SelectInput.tsx)
  const { handleChange } = useContext(FormContext) as { handleChange?: (event: any) => void };
  const {
    disabled,
    makeId,
    models,
    getVehicleModels,
    onChange,
    name = 'modelId',
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);

  const loadData = (): Promise<unknown> => {
    if (makeId) {
      setLoading(true);

      return getVehicleModels(makeId).finally(() => setLoading(false));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    mounted(loadData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [makeId]);

  return (
    <SelectInput
      { ...rest }
      name={ name }
      data={ models }
      dataTitle='title'
      dataValue='id'
      loading={ loading }
      disabled={ disabled || loading }
      onChange={ (event) => { handleChange(event);if (typeof onChange === 'function') onChange(event); } }
      sort
    />
  );
};

const mapStateToProps = (state) => {
  return {
    models: state.vehicles?.models,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVehicleModels: payload => dispatch(actions.getVehicleModels(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleModelSelector);
